import { I18nComponente } from "@/types/gerais"

export const TImportacoesi18n: I18nComponente = {
  "pt-BR": {
    atividadesPlanejadas: "atividades planejadas",
    eventosDeAtividadesPlanejadas: "eventos de atividades planejadas",
    importar: "importar",
    importacoesDeTiposDeAtividade: "selecione ou arraste arquivos para iniciar a importação de tipos de atividade vinculados a projetos.",
    importacoesDeEventos: "selecione ou arraste arquivos para iniciar a importação de eventos ou atividades em datas específicas."
  },
  "es-CO": {
    atividadesPlanejadas: "actividades planeadas",
    eventosDeAtividadesPlanejadas: "eventos de actividades planeadas",
    importar: "importar",
    importacoesDeTiposDeAtividade: "seleccione o arrastre archivos para iniciar la importación de tipos de actividad vinculados a proyectos.",
    importacoesDeEventos: "seleccione o arrastre archivos para iniciar la importación de eventos o actividades en fechas específicas."
  }
}
